// extracted by mini-css-extract-plugin
module.exports = {"commentWrapper":"ProgramComments__commentWrapper___2QREl"};